import { graphqlAjax } from '..'
import { gql } from 'apollo-boost'
import { ROLEID, STATUS } from '@GUTIL/hardCode'

export default {
  /**
   * Query
   */
  getAllAddress: params => {
    const query = gql`
      query($in: AddressFilterInput!) {
        allAddress(in: $in) {
          data {
            id
            addr
            device_id
            status
            section {
              id
              name
              addrs {
                id
                status
              }
              addr_binding_mode
            }
            customer_services {
              id
              nickname
              username
            }
            business_group {
              id
              nickname
            }
            updater {
              id
              username
            }
            updated_at
            op_link
          }
          meta {
            total
          }
        }
      }
    `
    return graphqlAjax('get', query, params)
  },
  getAddress: params => {
    const query = gql`
      query($id: Int!) {
        address(id: $id) {
          id
          addr
          device_id
          status
          section {
            id
            name
            addrs {
              id
              status
            }
            addr_binding_mode
          }
          customer_services_whitelist {
            id
            nickname
            username
          }
          business_group {
            id
            nickname
          }
          op_link
        }
      }
    `
    return graphqlAjax('get', query, params)
  },

  getAddressSelectedOptions: () => {
    const query = gql`
      query($accountIn: AccountsFilterInput, $sectionIn: SectionsFilterInput!) {
        allAccounts(filter: $accountIn) {
          data {
            id
            nickname
            username
          }
        }
        allSections(in: $sectionIn) {
          data {
            id
            name
            addrs {
              id
              status
            }
            addr_binding_mode
            customer_services {
              id
              nickname
              username
            }
          }
        }
      }
    `
    return graphqlAjax('get', query, {
      accountIn: {
        status: STATUS.ENABLE,
        role_ids: [ROLEID.BUSINESS_GROUP],
        base_filter: { page: 1, per_page: -1 }
      },
      sectionIn: {
        base_filter: { page: 1, per_page: -1 }
      }
    })
  },
  getAllAddressNotifyList: () => {
    const query = gql`
      query {
        allAddressNotifyList {
          data {
            id
            section_name
          }
        }
      }
    `
    return graphqlAjax('get', query, null)
  },

  /**
   * Mutation
   */
  createAddress: (params, opts = {}) => {
    const mutation = gql`
      mutation($in: CreateAddressInput!) {
        createAddress(in: $in)
      }
    `
    return graphqlAjax('post', mutation, params, opts)
  },
  updateAddress: (params, opts = {}) => {
    const mutation = gql`
      mutation($id: Int!, $in: UpdateAddressInput!) {
        updateAddress(id: $id, in: $in)
      }
    `
    return graphqlAjax('post', mutation, params, opts)
  },
  batchCreateAddress: params => {
    const mutation = gql`
      mutation($in: [CreateAddressInput!]!) {
        batchCreateAddress(in: $in) {
          is_successful
          is_failed
          err_msg
        }
      }
    `
    return graphqlAjax('post', mutation, params)
  },
  deleteAddressNotify: params => {
    const mutation = gql`
      mutation($id: String!) {
        deleteAddressNotify(id: $id)
      }
    `
    return graphqlAjax('post', mutation, params)
  },
  batchUpdateAddress: params => {
    const mutation = gql`
      mutation($addresses: [String!]!, $in: BatchUpdateAddressInput!) {
        batchUpdateAddress(addresses: $addresses, in: $in) {
          is_successful
          is_failed
          err_msg
          err_code
        }
      }
    `
    return graphqlAjax('post', mutation, params)
  }
}
